import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ALERTS, Constants } from 'src/app/common';
import { ICompany } from 'src/app/models/i-company';
import { AlertsService } from 'src/app/services/alerts.service';
import { BlockUiHandlerService } from 'src/app/services/block-ui-handler.service';
import { CrediserverService } from 'src/app/services/crediserver.service';
import { CompanyService } from '../../services/company.service';

@Component({
  selector: 'app-crediserver-configuration',
  templateUrl: './crediserver-configuration.component.html',
  styleUrls: ['./crediserver-configuration.component.css']
})
export class CrediserverConfigurationComponent implements OnInit {
  company: ICompany;
  companyForm: FormGroup;
  checkPass: boolean;
  checkRnpPass: boolean;

  constructor(
    private companyService: CompanyService,
    private alertsService: AlertsService,
    private blockUiService: BlockUiHandlerService,
    private crediserverService: CrediserverService,
    private blockUiHanddler: BlockUiHandlerService,
    private formBuilder: FormBuilder) { }

  ngOnInit(): void {
    this.InitVariables();
  }

  InitVariables(): void {
    this.ResetCompanyForm();
    this.LoadData();
  }

  LoadData(): void {
    this.LoadDefaultCompany();
  }

  ResetCompanyForm(): void {
    this.checkPass = false;
    this.checkRnpPass = false;
    this.companyForm = this.formBuilder.group({
      Id: [-1],
      Name: ['', Validators.required],
      ExecutionDay: ['', Validators.required],
      ExecutionTime: ['', Validators.required],
      CrediServerUser: ['', Validators.required],
      CrediServerPass: ['', Validators.required],
      // Credenciales del Registro Nacional (opcionales: el robot solo enriquece vía RNP
      // si ambas están cargadas). Ver enriquecimiento en el robot CrediServer.
      RegistroNacionalUser: [''],
      RegistroNacionalPass: [''],
      ChromeSendMailDate: ['', Validators.required],
      TagSendMailDate: ['', Validators.required],
      Active: [true, Validators.required]
    });
  }
  
  LoadDefaultCompany(): void {
    this.blockUiService.Start(1, "Cargando configuraciones...")
    this.companyService.GetDefaultCompany().subscribe(req => {
      this.blockUiService.Stop();
      if (req.Result) {
        this.company = req.Data;
        this.companyForm.setValue(req.Data);
      }
      else {
        this.alertsService.ShowSmallCornerAlert(`Error: ${req.ErrorInfo.Message}`, ALERTS.warning);
      }
    }, error => {
      this.blockUiService.Stop();
      this.alertsService.ShowSmallCornerAlert(`Error: ${error}`, ALERTS.warning);
    });
  }

  StoreCompany(): void {
    let Company: ICompany = this.companyForm.value as ICompany;
    if(this.checkPass && Company.CrediServerPass === '') {
      this.alertsService.ShowBigCenteredAlert("La contraseña esta requerida, desmarquela si no desea guardarla", 3);
    } else if(this.checkRnpPass && Company.RegistroNacionalPass === '') {
      this.alertsService.ShowBigCenteredAlert("La contraseña del Registro Nacional esta requerida, desmarquela si no desea guardarla", 3);
    } else {
      this.blockUiService.Start(1, 'Guardando configuración...');
      this.companyService.StoreCompany(Company).subscribe(req => {
        if (req.Result) {
          this.blockUiService.Stop();
          this.alertsService.ShowSmallCornerAlert(`Configuración actualizada`, ALERTS.success);
        }
        else {
          this.blockUiService.Stop();
          this.alertsService.ShowBigCenteredAlert(`Error: ${req.ErrorInfo.Message}`, ALERTS.error);
        }
      }, error => {
        this.blockUiService.Stop();
        this.alertsService.ShowBigCenteredAlert(`Error: ${error}`, ALERTS.error);
      });
    }
  }

  loadCrediserverService(){
    this.blockUiHanddler.Start(1, "Ejecutando servicio, esto puede tardar varios minutos...")
    this.crediserverService.LoadCrediserverPeople().subscribe(req => {
      if(req.Result){
        this.blockUiHanddler.Stop()
        this.alertsService.ShowBigCenteredAlert("Servicio ejecutado exitosamente", 1);
      } else {
        this.alertsService.ShowSmallCornerAlert(req.ErrorInfo.Message, 2)
        this.blockUiHanddler.Stop()
      }
    }, err => {
      this.alertsService.ShowSmallCornerAlert(err, 2)
      this.blockUiHanddler.Stop()
    })
  }

  FormatInput(input: HTMLInputElement): void {
    input.value = input.value.replace(Constants.FILTER_DAY_REGEX, '');
    if(parseInt(input.value) > 30) input.value = '31';
    if(parseInt(input.value) < 1) input.value = '1';
  }

  CheckPass(){
    if(this.checkPass)
      this.companyForm.controls['CrediServerPass'].setValue('');
    this.checkPass = !this.checkPass;
  }

  CheckRnpPass(){
    if(this.checkRnpPass)
      this.companyForm.controls['RegistroNacionalPass'].setValue('');
    this.checkRnpPass = !this.checkRnpPass;
  }


}
